import type { RouteRecordRaw } from 'vue-router';

export const monthsRoute: RouteRecordRaw = {
  path: '/dates/months',
  name: 'DatesMonths',
  component: () => import('./pages/DatesMonthsPage.vue'),
  meta: { layout: 'main' },
};

export const wordsRoute: RouteRecordRaw = {
  path: '/dates/words',
  name: 'DatesWords',
  component: () => import('./pages/DateWordsPage.vue'),
  meta: { layout: 'main' },
};

export const practiceRoute: RouteRecordRaw = {
  path: '/dates/practice',
  name: 'DatesPractice',
  component: () => import('./pages/DatesPracticePage.vue'),
  meta: { layout: 'main' },
};
